import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c711ef4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Nome", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Usuário", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Status", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Permissão", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Data de Criação", -1))
const _hoisted_7 = { class: "user-name" }
const _hoisted_8 = { class: "user-permission" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "permission-title" }, " Permissão: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "permission-dots" }, "...", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-group" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button delete-button" }, "Cancelar"),
  /*#__PURE__*/_createElementVNode("button", { class: "button save-button" }, "Salvar")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBar = _resolveComponent("TitleBar")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_PermissionCard = _resolveComponent("PermissionCard")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_StructureList = _resolveComponent("StructureList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleBar, { title: "Permissões" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageHeader, null, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
        return (_openBlock(), _createBlock(_component_PermissionCard, {
          onClick: ($event: any) => (_ctx.showModal(user)),
          key: user.name,
          user: user
        }, null, 8, ["onClick", "user"]))
      }), 128)),
      (_ctx.selectedUser)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 0,
            onCloseModalClick: _ctx.hideModal,
            "is-active": _ctx.modalActive,
            title: _ctx.selectedUser?.username
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-user" })
            ]),
            body: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.selectedUser?.name), 1),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", {
                  class: "permission-value",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showStructuresModal && _ctx.showStructuresModal(...args)))
                }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.selectedUser.permission), 1),
                  _hoisted_10
                ])
              ])
            ]),
            footer: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onCloseModalClick", "is-active", "title"]))
        : _createCommentVNode("", true),
      (_ctx.modalStructuresActive)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 1,
            onCloseModalClick: _ctx.hideStructuresModal,
            isActive: _ctx.modalStructuresActive,
            title: "Permissão"
          }, {
            body: _withCtx(() => [
              _createVNode(_component_StructureList)
            ]),
            _: 1
          }, 8, ["onCloseModalClick", "isActive"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}